import { createAction, createReducer } from '@reduxjs/toolkit';
import { IApiType } from './interface/apiInterface';
import { IInitialState } from './interface/reduxInterface';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  dateSearch: {
    start: '',
    end: '',
  },
  terceiros: {
    saldo_inicial: 0,
    saldo_final: 0,
    teds: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    pix: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    tarifas_pagas_a_fiducia: {
      valor_enviado: 0,
    },
    tarifas_pagas_a_wl: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    pagamentos_celcoin: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    recebimento_tev_interna: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    domicilio_bancario: {
      valor_recebido: 0,
      valor_enviado: 0,
    },
    boletos_liquidados: {
      valor_recebido: 0,
    },
    tev_entre_ambiente: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    cartao: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    cripto: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
  },
  fiducia: {
    saldo_inicial: 0,
    saldo_final: 0,
    teds: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    pix: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    tarifas_pagas: {
      valor_enviado: 0,
    },
    tarifas_pagas_a_fiducia: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    tarifas_tib_slb: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    pagamentos_celcoin: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    fgts: {
      valor_recebido: 0,
      valor_enviado: 0,
    },
    investimento: {
      valor_recebido: 0,
    },
    recebimento_tev_interna: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    domicilio_bancario: {
      valor_recebido: 0,
    },
    boletos_liquidados: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    tev_entre_ambiente: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    cartao: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
    cripto: {
      valor_enviado: 0,
      valor_recebido: 0,
    },
  },
};

export const getAccountingV2ReportFromApi = createAction(
  '@accountingApp/GET_ACCOUNTINGV2_REPORT_FROM_API'
);
export const gotAccountingV2ReportFromApi = createAction<any>(
  '@accountingApp/GOT_ACCOUNTINGV2_REPORT_FROM_API'
);
export const gotErrorFromAccountingV2ReportApi = createAction(
  '@accountingApp/GOT_ERROR_FROM_ACCOUNTINGV2_REPORT_API'
);

const accountingAppV2Reducer = createReducer(INITIAL_STATE, {
  [getAccountingV2ReportFromApi.type]: (state: any) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: true,
  }),
  [gotErrorFromAccountingV2ReportApi.type]: (state: any) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),

  [gotAccountingV2ReportFromApi.type]: (state, action: IApiType) => ({
    ...state,
    isActive: true,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    dateSearch: {
      start: action.payload.data_de_pesquisa.de,
      end: action.payload.data_de_pesquisa.ate,
    },
    fiducia: {
      saldo_inicial: action.payload.fiducia.saldo_inicial,
      saldo_final: action.payload.fiducia.saldo_final,
      teds: {
        valor_enviado: action.payload.fiducia.teds.valor_enviado,
        valor_recebido: action.payload.fiducia.teds.valor_recebido,
      },
      pix: {
        valor_enviado: action.payload.fiducia.pix.valor_enviado,
        valor_recebido: action.payload.fiducia.pix.valor_recebido,
      },
      tarifas_pagas_a_fiducia: {
        valor_enviado:
          action.payload.fiducia.tarifas_pagas_a_fiducia.valor_enviado,
        valor_recebido:
          action.payload.fiducia.tarifas_pagas_a_fiducia.valor_recebido,
      },
      tarifas_pagas: {
        valor_enviado: action.payload.fiducia.tarifas_pagas.valor_enviado,
      },
      tarifas_tib_slb: {
        valor_enviado: action.payload.fiducia.tarifas_tib_slb.valor_enviado,
        valor_recebido: action.payload.fiducia.tarifas_tib_slb.valor_recebido,
      },
      pagamentos_celcoin: {
        valor_enviado: action.payload.fiducia.pagamentos_celcoin.valor_enviado,
        valor_recebido:
          action.payload.fiducia.pagamentos_celcoin.valor_recebido,
      },
      fgts: {
        valor_enviado: action.payload.fiducia.fgts.valor_enviado,
        valor_recebido: action.payload.fiducia.fgts.valor_recebido,
      },
      investimento: {
        valor_enviado: action.payload.fiducia.investimento.valor_enviado,
        valor_recebido: action.payload.fiducia.investimento.valor_recebido,
      },
      recebimento_tev_interna: {
        valor_enviado:
          action.payload.fiducia.recebimento_tev_interna.valor_enviado,
        valor_recebido:
          action.payload.fiducia.recebimento_tev_interna.valor_recebido,
      },
      domicilio_bancario: {
        valor_enviado: action.payload.fiducia.domicilio_bancario.valor_enviado,
        valor_recebido:
          action.payload.fiducia.domicilio_bancario.valor_recebido,
      },
      boletos_liquidados: {
        valor_enviado: action.payload.fiducia.boletos_liquidados.valor_enviado,
        valor_recebido:
          action.payload.fiducia.boletos_liquidados.valor_recebido,
      },
      tev_entre_ambiente: {
        valor_enviado: action.payload.fiducia.tev_entre_ambiente.valor_enviado,
        valor_recebido:
          action.payload.fiducia.tev_entre_ambiente.valor_recebido,
      },
      cartao: {
        valor_enviado: action.payload.fiducia.cartao.valor_enviado,
        valor_recebido: action.payload.fiducia.cartao.valor_recebido,
      },
      cripto: {
        valor_enviado: action.payload.fiducia.cartao.valor_enviado,
        valor_recebido: action.payload.fiducia.cartao.valor_recebido,
      },
    },
    terceiros: {
      saldo_inicial: action.payload.terceiros.saldo_inicial,
      saldo_final: action.payload.terceiros.saldo_final,
      cartao: {
        valor_enviado: action.payload.terceiros.cartao.valor_enviado,
      },
      teds: {
        valor_enviado: action.payload.terceiros.teds.valor_enviado,
        valor_recebido: action.payload.terceiros.teds.valor_recebido,
      },
      pix: {
        valor_enviado: action.payload.terceiros.pix.valor_enviado,
        valor_recebido: action.payload.terceiros.pix.valor_recebido,
      },
      tarifas_pagas_a_fiducia: {
        valor_enviado:
          action.payload.terceiros.tarifas_pagas_a_fiducia.valor_enviado,
        valor_recebido:
          action.payload.terceiros.tarifas_pagas_a_fiducia.valor_recebido,
      },
      tarifas_pagas_a_wl: {
        valor_enviado:
          action.payload.terceiros.tarifas_pagas_a_wl.valor_enviado,
        valor_recebido:
          action.payload.terceiros.tarifas_pagas_a_wl.valor_recebido,
      },
      pagamentos_celcoin: {
        valor_enviado:
          action.payload.terceiros.pagamentos_celcoin.valor_enviado,
        valor_recebido:
          action.payload.terceiros.pagamentos_celcoin.valor_recebido,
      },
      recebimento_tev_interna: {
        valor_enviado:
          action.payload.terceiros.recebimento_tev_interna.valor_enviado,
        valor_recebido:
          action.payload.terceiros.recebimento_tev_interna.valor_recebido,
      },
      domicilio_bancario: {
        valor_enviado:
          action.payload.terceiros.domicilio_bancario.valor_enviado,
        valor_recebido:
          action.payload.terceiros.domicilio_bancario.valor_recebido,
      },
      boletos_liquidados: {
        valor_enviado:
          action.payload.terceiros.boletos_liquidados.valor_enviado,
        valor_recebido:
          action.payload.terceiros.boletos_liquidados.valor_recebido,
      },
      tev_entre_ambiente: {
        valor_enviado:
          action.payload.terceiros.tev_entre_ambiente.valor_enviado,
        valor_recebido:
          action.payload.terceiros.tev_entre_ambiente.valor_recebido,
      },
      cripto: {
        valor_recebido: 0,
        valor_enviado: action.payload.fiducia.cartao.valor_enviado,
      },
    },
  }),

  [gotErrorFromAccountingV2ReportApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
});

export default accountingAppV2Reducer;
